import axios from '@/libs/api.request'

export const getDispatchpersonlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/dispatchperson/dispatchperson/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationDispatchperson = (data, meth) => {
  return axios.request({
    url: '/v1/dispatchperson/dispatchperson/',
    method: meth,
    data
  })
}
